'use client';

import { useEffect } from 'react';
import { fetchOrgProducts } from 'modules/products/actions';
import { useAppDispatch, useAppSelector } from 'hooks';
import { isAdmin } from 'components/AdminOnly';

// Mock product data
// const productData: AvailableProduct[] = [
//   {
//     id: 'PROD-1',
//     title: 'AKS Støvbinder - ekstraskridsikring',
//     availableUnits: ['5 liter', '220 liter', '1000 liter'],
//     defaultUnit: '220 liter',
//   },
//   {
//     id: 'PROD-2',
//     title: 'AKS Støvbinder - fejegranulat',
//     availableUnits: ['25 liter', '1000 liter'],
//     defaultUnit: '25 liter',
//   },
// ];

// has to be in sync with the product data in the backend function onOrdreUpdate
const staticProducts = [
  {
    id: 'sensor',
    title: 'Sensor (indeklima)',
    availableUnits: ['stk'],
    defaultUnit: 'stk',
  },
  {
    id: 'levelsensor',
    title: 'Niveau måler',
    availableUnits: ['stk'],
    defaultUnit: 'stk',
  },
  {
    id: 'dosering',
    title: 'Doseringsanlæg',
    availableUnits: ['stk'],
    defaultUnit: 'stk',
  },
  {
    id: 'dustmeasurements',
    title: 'Støvmålinger før og efter',
    availableUnits: ['stk'],
    defaultUnit: 'stk',
  },
  {
    id: 'gps',
    title: 'GPS',
    availableUnits: ['stk'],
    defaultUnit: 'stk',
  },
  {
    id: 'aksBW',
    title: 'AKS BW',
    availableUnits: ['l'],
    defaultUnit: 'l',
  },
  {
    id: 'brightwater',
    title: 'Brightwater',
    availableUnits: ['l'],
    defaultUnit: 'l',
  },
  {
    id: 'fryse-sand',
    title: 'Fryse sand',
    availableUnits: ['kg'],
    defaultUnit: 'kg',
  },
  {
    id: 'ubbc',
    title: 'Univar Black Box Clairity+',
    availableUnits: ['kg'],
    defaultUnit: 'kg',
  },
];

export function useProducts(orgId: string) {
  const dispatch = useAppDispatch();
  const products = useAppSelector((state) => state.products.orgProducts);
  const userId = useAppSelector((state) => state.user.details.uid);
  const isUserAdmin = isAdmin(userId);
  // console.log({ products });

  // const [products, setProducts] = useState<AvailableProduct[]>([]);

  useEffect(() => {
    if (!orgId) return;
    // In a real app, this would be an API call
    dispatch(fetchOrgProducts(orgId));
    // setProducts(productData);
  }, [orgId]);

  const filteredStaticProducts = isUserAdmin
    ? staticProducts
    : staticProducts.filter((p) => p.id !== 'ubbc');

  return {
    products: [
      ...(products || []).map((p) => ({
        ...p,
        defaultUnit: p.availableUnits?.[0],
      })),
      ...filteredStaticProducts,
    ],
    loadingProducts: false,
  };
}
